import React from 'react';
import styled from 'styled-components';
import { useObserver } from 'mobx-react-lite';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useUser from 'src/hooks/use-user';

import { Loyalty as LoyaltyIcon } from 'src/assets/loyalty';
import { PinField } from 'shared/components';
import { TextButton } from 'src/components/core';
import { Statuses } from 'src/components/loyalty/use-loyalty';

type PinProps = {
  status: Statuses;
  processPin: (pin: string) => void;
  resendPin: () => Promise<void>;
  programName: string;
};

export const Pin = ({ status, processPin, resendPin, programName }: PinProps): JSX.Element => {
  const { dispensary } = useDispensary();
  const User = useUser();
  const phone = useObserver(() => User.phone);
  const hasError = status === Statuses.incorrectPin;

  return (
    <Container data-testid='loyalty-pin'>
      <LoyaltyIcon />

      <div>
        <Heading>Connect to {programName}</Heading>

        <p>
          Enter the code we sent to (***) *** - {phone.slice(-4)} to connect your {dispensary.name} {programName}{' '}
          account.
        </p>
      </div>

      <PinField onComplete={processPin} />

      {hasError && <Error>Invalid code, try again</Error>}

      <StyledTextButton onClick={resendPin}>{hasError ? 'Send a new code' : 'Resend code'}</StyledTextButton>
    </Container>
  );
};

const Container = styled.div`
  align-items: center;
  color: #646d72;
  display: flex;
  flex-direction: column;
  gap: 24px;
  text-align: center;
`;

const Heading = styled.h3`
  color: #121516;
  font-size: 18px;
  margin-bottom: 8px;
`;

const StyledTextButton = styled(TextButton)`
  font-weight: 600;
`;

const Error = styled.div`
  color: ${({ theme }) => theme.colors.red[55]};
  font-size: 13px;
  font-weight: 600;
`;
